export const COPYRIGHT_NOTICE = `Copyright © ${new Date().getFullYear()}, MaD Software`;
